import { error } from 'scripts/utils/message'

import { updateProject } from 'lmcv/services/customers'

import {
  FAIL_FINISH_PROJECT,
  FAIL_DELETE_CLIENT
} from './constants'

export const finishProject = (id, onClose) => {
  onClose()
  updateProject(id, { status: 'cancelled' })
    .then(({ status }) => {
      window.location = '/fidelidade/clientes'
    })
    .catch(e => {
      error(FAIL_FINISH_PROJECT)
    })
}

export const deleteClient = (id, onClose) => {
  onClose()
  updateProject(id, { status: 'excluded' })
    .then(({ status }) => {
      window.location = '/fidelidade/clientes'
    })
    .catch(e => {
      error(FAIL_DELETE_CLIENT)
    })
}
